// extracted by mini-css-extract-plugin
export default {"container":"Card_container__0q3Jy","content":"Card_content__O3dT5","img":"Card_img__i7dk1","text":"Card_text__oa7U3"};